// const { GET_PROMPT_LIST } = require("adapters/ehr.service");

import { GET_PROMPT_LIST_NEW } from "adapters/ehr.service";
import { TEMPLATES } from "../Constants/templateConstants";

const getAvailableTemplates = async () => {
  // const promptList = TEMPLATES;

  let promptList = await GET_PROMPT_LIST_NEW();

  promptList = promptList?.map?.((item) => ({
    ...item,
    prompt_code: item?.promptCode,
    prompt_name: item?.promptName
}));

  const sortHelper = [
    "soap-note-first-visit",
    "soap-note-follow-up-visit",
    "soap-note-general",
  ];

  let sortedPromptList = promptList?.map((item) => ({
    ...item,
    label: item?.prompt_name,
    value: item?.prompt_code,
  }));

  sortedPromptList?.sort((a, b) => {
    const indexA = sortHelper.indexOf(a.value);
    const indexB = sortHelper.indexOf(b.value);

    if (indexA === -1 && indexB === -1) {
      return 0;
    }
    if (indexA === -1) {
      return 1;
    }
    if (indexB === -1) {
      return -1;
    }
    return indexA - indexB;
  });

  sortedPromptList?.forEach?.((item) => {
    if (
      item?.prompt_code !== "cdss-prompt" &&
      item?.prompt_code !== "translate-content" &&
      item?.prompt_code !== "extract-clinical-keywords" &&
      item?.prompt_code !== "clean-up" &&
      item?.prompt_code !== "translate-content" &&
      item?.prompt_code !== "generate-title-based-on-conversation" &&
      item?.prompt_code !== "ai-voice-editor" &&
      item?.prompt_code !== "ai-voice-editor-for-referral" &&
      item?.prompt_code !== "cybermed-first-visit" &&
      item?.prompt_code !== "dynamic_language_converter_for_soap_note" &&
      item?.prompt_code !== "ai-voice-editor-for-soap-note" &&
      item?.prompt_code !== "ai-voice-editor-for-referral-letter" &&
      item?.prompt_code !== "icd-codes-prompt" &&
      item?.prompt_code !== "cpt-codes-prompt" &&
      item?.prompt_code !== "extract-clinical-keywords" &&
      !item?.prompt_code?.includes("context")
    ) {
      item.visibility = true;
    } else {
      item.visibility = false;
    }
    if (
      (item?.prompt_code?.includes("SOAP") ||
        item?.prompt_code?.includes("soap")) &&
      item?.prompt_code !== "referral-letter-with-previous-soap-note-as-context"
    ) {
      item.clinicalNote = true;
    } else {
      item.clinicalNote = false;
    }
  });

  // sortedPromptList = sortedPromptList?.filter(
  //     (f) =>
  //         f?.prompt_code !== "cdss-prompt" &&
  //         f?.prompt_code !== "clean-up" &&
  //         f?.prompt_code !== "generate-title-based-on-conversation" &&
  //         f?.prompt_code !== "ai-voice-editor" &&
  //         !f?.prompt_code?.includes("context")
  // );

  return sortedPromptList;
};

export { getAvailableTemplates };
